import React from 'react';
import EInvoiceAccessLayout from '../../../components/EInvoiceAccessLayout';
import { useRoleModuleLabel } from '../../../hooks/useRoleModuleLabel';
import { READ_PURCHASE_CREDIT_NOTE, READ_PURCHASE_INVOICE } from '../../../constants/eInvoicePermissions';
import { PURCHASE_MODULE_KEY } from '../../settings/constants/roleModules';

export default function PurchaseDocumentsAccessLayout() {
  const title = useRoleModuleLabel(PURCHASE_MODULE_KEY);

  return <EInvoiceAccessLayout permissions={[READ_PURCHASE_INVOICE, READ_PURCHASE_CREDIT_NOTE]} title={title} />;
}
